module.exports = __webpack_public_path__ + "static/img/news-qrcode.f024f60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images-en/news-qrcode.png
// module id = lJJS
// module chunks = 1